__turbopack_context__.v({
  "bg": "index-module-scss-module__ZJdFPW__bg",
  "saveUpBg": "index-module-scss-module__ZJdFPW__saveUpBg",
  "textColor": "index-module-scss-module__ZJdFPW__textColor",
});
